import { render, staticRenderFns } from "./ActiveUsers.vue?vue&type=template&id=140f19e4&"
import script from "./ActiveUsers.vue?vue&type=script&lang=js&"
export * from "./ActiveUsers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports